if (!customElements.get('product-restock')) {
  customElements.define('product-restock', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      if (!this.scope) return;

      this.hidden = !!this.scope.querySelector('variant-selects [data-required-size-option]');
      this.events = new AbortController();
      const options = { capture: true, signal: this.events.signal };
      this.scope.addEventListener('click', (event) => this.onSelection(event), options);
      this.scope.addEventListener('change', (event) => this.onSelection(event), options);
      document.addEventListener('stretchshop:sticky-size-selected', (event) => this.onStickySelection(event), options);
    }

    disconnectedCallback() {
      this.events?.abort();
      this.cancel();
    }

    cancel() {
      clearTimeout(this.timer);
      this.pending = null;
    }

    selectedOptions(picker) {
      return Array.from(picker.querySelectorAll('.product-form__input')).map((group) => {
        return group.querySelector('input[type="radio"]:checked, select')?.value ?? null;
      });
    }

    onSelection(event) {
      const target = event.target;
      // Labels produce a native input click, including clicks on the envelope icon.
      // Listen to that input, so one label click cannot open the popup twice.
      if (!target.matches('input[type="radio"], select')) return;
      if (event.type === 'click' && target.tagName === 'SELECT') return;
      const picker = target.closest('variant-selects');
      if (!picker || target.disabled) return;

      if (!target.closest('[data-required-size-option]')) {
        this.cancel();
        return;
      }

      this.queueSelection(picker);
    }

    onStickySelection(event) {
      const sticky = event.target;
      if (!(sticky instanceof Element) || !sticky.matches('sticky-atc-bar')) return;
      if (!this.scope.dataset.section || sticky.dataset.section !== this.scope.dataset.section) return;

      // The sticky bar has already selected the main picker's options. Reuse
      // the same wait for Hyper and Klaviyo without clicking or focusing a radio.
      const picker = this.scope.querySelector('variant-selects');
      if (!picker?.querySelector('[data-required-size-option]')) return;
      this.queueSelection(picker);
    }

    queueSelection(picker) {
      const values = this.selectedOptions(picker);
      if (this.pending && JSON.stringify(this.pending.values) === JSON.stringify(values)) return;
      this.cancel();
      if (values.some((value) => value === null)) return;

      this.pending = { values, expires: Date.now() + 10000 };
      this.timer = setTimeout(() => this.openWhenReady(), 100);
    }

    openWhenReady() {
      if (!this.pending || !this.isConnected) return;
      const picker = this.scope.querySelector('variant-selects');
      if (!picker || Date.now() > this.pending.expires) {
        this.cancel();
        return;
      }

      let variant;
      try {
        variant = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || 'null');
      } catch (_) {
        // Hyper can be in the middle of replacing the variant picker.
      }

      // Wait for Hyper's response, not just the visually crossed-out size.
      const matches = variant?.options?.length === this.pending.values.length &&
        variant.options.every((value, index) => value === this.pending.values[index]);
      if (matches) {
        if (variant.available) {
          this.cancel();
          return;
        }

        // Klaviyo renders its real button next to .klaviyo-bis-trigger. Do not
        // use openForm: the native BIS button keeps the product/variant context.
        const button = this.querySelector('#klaviyo-bis-button-container button');
        const variantId = String(variant.id);
        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        const formVariant = document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value;
        // Klaviyo reads the URL first, then the product form. Wait until Hyper
        // has updated both, so a fast size change cannot use the previous size.
        if (button && !button.disabled && urlVariant === variantId && formVariant === variantId) {
          this.cancel();
          button.click();
          return;
        }
      }

      this.timer = setTimeout(() => this.openWhenReady(), 100);
    }
  });
}
